import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { IUser } from '../../../User'
import {
	mapRightsNullToNoPermission
} from '../../../../shared/lib/mappers/mapRightsNullToNoPermission'
import { mapCSuite } from '../../../../shared/lib/mappers/mapCSuite'
import { AUTH_USER_LS_KEY } from '../constants/constants'

export const fetchAuthUser = createAsyncThunk<IUser, void, ThunkConfig<string>>(
	'authUser/fetchAuthUser',
	async (_, thunkAPI) => {
		const {
			extra: { api },
			rejectWithValue
		} = thunkAPI

		try {
			const { data: user } = await api.get<IUser>('/users/own')

			const authUser = mapRightsNullToNoPermission(user)
			mapCSuite(authUser)
			localStorage.setItem(AUTH_USER_LS_KEY, JSON.stringify(authUser))

			return authUser
		} catch (e) {
			console.log(e)
			appHandleError(e, 'fetchAuthUser', 'Error on auth user data fetch')
			return rejectWithValue('Error occurred on auth user data fetch')
		}
	}
)